import { Store } from 'pullstate';

export interface IRequestsStore {
  [i: string]: unknown;
}

export const RequestsStore = new Store<IRequestsStore>({});
